module.exports = __webpack_public_path__ + "img/Eval_BlockDiagram.7ded5fc2.png";